// eslint-disable-next-line import/prefer-default-export,consistent-return
export const domain = (type) => {
  if (type === 'homepage')
    return process.env.ENV === 'production' ? 'https://sikdae.com/' : 'https://homepage.mealc.co.kr/';
};
